import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import data from '../../data/contact';

const ContactIcons: React.FC = () => (
  <ul className="icons">
    {data.map((s) => (
      <li key={s.label}>
        <a
          href={s.link}
          aria-label={s.label}
          {...(s.link.startsWith('http') ? { target: '_blank', rel: 'noreferrer' } : {})}
        >
          <FontAwesomeIcon icon={s.icon} />
        </a>
      </li>
    ))}
  </ul>
);

export default ContactIcons;

